var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissionLevel5 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7593 5.4306L11.7633 3.03064C11.6431 2.98979 11.5143 2.98979 11.3942 3.03064L4.39821 5.4306C4.16032 5.51283 4 5.74145 4 6.00005V12C4 18.5937 11.3358 20.9512 11.4104 20.9748C11.4652 20.9916 11.5218 21 11.5789 21C11.6361 21 11.6927 20.9916 11.7475 20.9748C11.822 20.9514 19.1579 18.594 19.1579 12V6.00005C19.1579 5.74143 18.9977 5.51282 18.7593 5.4306Z",
    fill: "#5DA6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5126 15.6C13.1641 15.6 14.3186 14.5439 14.3186 13.0063V12.9959C14.3186 11.5774 13.2935 10.5471 11.8698 10.5471C11.1192 10.5471 10.5031 10.8422 10.1769 11.3444H10.151L10.3581 9.09237H13.8786V8H9.29163L8.93441 12.3436H10.0993C10.1873 12.1779 10.3115 12.033 10.4513 11.9191C10.736 11.6809 11.1036 11.5515 11.5281 11.5515C12.4031 11.5515 13.0295 12.1624 13.0295 13.0166V13.027C13.0295 13.9019 12.4134 14.5128 11.523 14.5128C10.736 14.5128 10.1666 14.0313 10.0578 13.4049L10.0527 13.3687H8.7998L8.80498 13.436C8.90335 14.6733 9.95948 15.6 11.5126 15.6Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissionLevel5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_permission_level_5.6e148f95d274b81670b07d212a3fe14a.svg";